import { canonize } from './validateUsername';

export default canonize;
